<div class=outer>

    <layout>
        <div class="container" >
        <h3 class=title 
        >{{config?.stillWondering}}</h3>
        <div class=split>
            <div class="right">
                <div class="card" >
                    <p class="card-title">{{config?.tryLessonTitle1}}</p>
                    <p class="card-body">{{config?.tryLessonDesc1}}</p>
                </div>
                <div class="card" >
                    <p class="card-title">{{config?.tryLessonTitle2}}</p>
                    <p class="card-body">{{config?.tryLessonDesc2}}</p>
                </div>
                    <div class="card" >
                    <p class="card-title">{{config?.tryLessonTitle3}}</p>
                    <p class="card-body">{{config?.tryLessonDesc3}}</p>
                </div>
        
                <div class="card" >
                    <p class="card-title">{{config?.tryLessonTitle4}}</p>
                    <p class="card-body">{{config?.tryLessonDesc4}}</p>
                </div>
                <!-- <div class="card" >
                    <p class="card-title">{{config?.tryLessonTitle5}}</p>
                    <p class="card-body">{{config?.tryLessonDesc5}}</p>
                </div>

                <div class="card" >
                    <p class="card-title">{{config?.tryLessonTitle6}}</p>
                    <p class="card-body">{{config?.tryLessonDesc6}}</p>
                </div> -->
                <gradient-button *ngIf="!profile?.currentLesson"  (click)=register()>{{config?.mainStartButton}}</gradient-button>
    <gradient-button *ngIf="profile?.currentLesson" (click)=register()>{{this.config?.resume}} {{profile?.currentLesson}}</gradient-button>
            </div>
            <div class="left">
                <div class="desktop" >
                    <app-ani2 mobile=false></app-ani2>
                </div>
                <div class="mobile">
                    <app-ani2 mobile=true></app-ani2>
                </div>
                
                <div class="actions">
                </div>
            </div>
        </div>
    </div>
    </layout>
    <div class="a b1" style="--order: 1"></div>
    <div class="b b2" style="--order: 2"></div>
    <div class="b b3" style="--order: 3"></div>
</div>